import { defHttp } from '/@/utils/http/axios';
import {
  LoginParams,
  LoginResultModel,
  GetUserInfoModel,
  SignUpParams,
  GetUserInfoTeamModel,
  LoginConfirmParams,
} from './model/userModel';
// import { BasicIdParams } from '/@/api/model/baseModel';
import { ErrorMessageMode } from '/#/axios';

export enum Api {
  GetUserInfo = `/user/user/permission`,
  GetPermCode = '/user/user/permission',
  USER = '/user',
  AUTH = '/user',
  ROLE = '/user/role',
}

export function loginConfirmApi(params: LoginConfirmParams, mode: ErrorMessageMode = 'none') {
  return defHttp.get<null>(
    {
      url: `${Api.AUTH}/login/confirm`,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>(
    {
      url: `${Api.AUTH}/login`,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>({ url: `${Api.USER}/logged` }, { errorMessageMode: 'none' });
}

export function getPermCode() {
  return defHttp.get<string[]>({ url: Api.GetPermCode });
}

export function doLogout() {
  return defHttp.get({ url: `${Api.USER}/logout` });
}

export interface RegistrationCaptcha {
  challengeId: string;
  imageDataUrl: string;
}

export function getRegistrationCaptcha() {
  return defHttp.get<RegistrationCaptcha>(
    { url: `${Api.AUTH}/register/captcha` },
    { errorMessageMode: 'none' },
  );
}

export function signUpEmail(params: { email: string; challengeId: string; captchaAnswer: string }) {
  // Aliyun DirectMail path — backend stores a 10-min code in Redis and
  // emails it to the user. Same target must be POSTed back in signUpApi.
  return defHttp.post<null>(
    {
      url: `${Api.AUTH}/register/sendEmailCode`,
      params: {
        target: params.email,
        challengeId: params.challengeId,
        captchaAnswer: params.captchaAnswer,
      },
      headers: {
        // @ts-ignore
        ignoreCancelToken: true,
      },
    },
    {
      errorMessageMode: 'none',
    },
  );
}

export function signUpApi(params: SignUpParams) {
  return defHttp.post<LoginResultModel>({
    url: `${Api.AUTH}/register`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
}

export const resetPwdSendEmail = (params: { email?: string; target?: string }) =>
  defHttp.post<null>({
    url: `${Api.AUTH}/resetPassword/sendCode`,
    params: { target: params.target ?? params.email },
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const resetPwdApi = (params: {
  target?: string;
  email?: string;
  code?: string;
  token?: string;
  newPassword: string;
}) =>
  defHttp.post<null>({
    url: `${Api.AUTH}/resetPassword`,
    params: {
      target: params.target ?? params.email,
      code: params.code ?? params.token,
      newPassword: params.newPassword,
    },
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const sendLoginSmsCode = (params: { phone: string }) =>
  defHttp.post<null>(
    {
      url: `${Api.AUTH}/login/sms/sendCode`,
      params: { target: params.phone },
      headers: {
        // @ts-ignore
        ignoreCancelToken: true,
      },
    },
    { errorMessageMode: 'none' },
  );

export const loginBySmsApi = (
  params: { phone: string; code: string },
  mode: ErrorMessageMode = 'modal',
) =>
  defHttp.post<LoginResultModel>(
    {
      url: `${Api.AUTH}/login/sms`,
      params,
    },
    { errorMessageMode: mode },
  );

export const sendLoginEmailCode = (params: { email: string }) =>
  defHttp.post<null>(
    {
      url: `${Api.AUTH}/login/email/sendCode`,
      params: { target: params.email },
      headers: {
        // @ts-ignore
        ignoreCancelToken: true,
      },
    },
    { errorMessageMode: 'none' },
  );

export const loginByEmailApi = (
  params: { email: string; code: string },
  mode: ErrorMessageMode = 'modal',
) =>
  defHttp.post<LoginResultModel>(
    {
      url: `${Api.AUTH}/login/email`,
      params,
    },
    { errorMessageMode: mode },
  );

export const updateUser = (params: {
  user: {
    avatarId?: number;
    nickname?: string;
    newPassword?: string;
    avatarUrl?: string;
    password?: string;
  };
}) =>
  defHttp.post<null>({
    url: `${Api.USER}/update`,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/** upload avatar */
export const uploadAvatar = (params: any) =>
  defHttp.uploadFile<any>(
    {
      url: `/api${Api.USER}/uploadAvatar`,
      headers: {
        // @ts-ignore
        ignoreCancelToken: true,
      },
    },
    params,
  );

export const fetchUser = (params: { id: string | number }) =>
  defHttp.get<GetUserInfoTeamModel>({
    url: `${Api.USER}/info/${params.id}`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

export const fetchPermission = () =>
  defHttp.get<string[]>({
    url: `${Api.USER}/permission`,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
